import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'addLink',
    'removeLink',
    'template',
    'counter',
    'fieldsWrapper',
    'separator'
  ];

  connect () {
    this.hideRemovedAssociations();
    this.refreshCounters();
    this.showSeparator();
  }

  addAssociation (event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    this.addLinkTarget.insertAdjacentHTML('beforebegin', content);
    this.refreshCounters();
    this.showSeparator();
  }

  removeAssociation (event) {
    event.preventDefault();

    const fieldsWrapper = event.currentTarget.closest(
      '[data-nested-form-target=fieldsWrapper]'
    );

    if (fieldsWrapper.dataset.newRecord === 'true') {
      fieldsWrapper.remove();
    } else {
      fieldsWrapper.querySelector("input[name*='_destroy']").value = 1;
      fieldsWrapper.style.display = 'none';
    }

    this.refreshCounters();
    this.showSeparator();
  }

  refreshCounters () {
    this.counterTargets
      .filter((counter) => {
        return (
          counter.closest('[data-nested-form-target=fieldsWrapper]').style
            .display !== 'none'
        );
      })
      .forEach((counter, i) => {
        counter.innerHTML = `${counter.dataset.text} ${i + 1}`;
      });
  }

  showSeparator () {
    this.separatorTargets
      .filter((separator) => {
        return (
          separator.closest('[data-nested-form-target=fieldsWrapper]').style
            .display !== 'none'
        );
      })
      .forEach((separator, i) => {
        if (i === 0) {
          separator.classList.add('d-none');
        } else {
          separator.classList.remove('d-none');
        }
      });
  }

  hideRemovedAssociations () {
    this.fieldsWrapperTargets.forEach((fieldsWrapper) => {
      if (
        fieldsWrapper.querySelector("input[name*='_destroy']")?.value === 'true'
      ) {
        fieldsWrapper.style.display = 'none';
      }
    });
  }

  _countNestedFields () {
    return this.fieldsWrapperTargets.length;
  }
}
